import api from '@/api'

const leftCountPosCode = 'officeside_pay_limit'

// 该store管理支付页多个组件的公共数据，避免组件间参数传递过多
// TODO: 当前支付页组件传参过多，比较复杂，后期有空将参数提取到该store中进行管理
export default {
  namespaced: true,
  state: () => ({
    packageIndexActive: 0, // 当前选择的套餐的index，目前可取0，1，2
    leftCountPackageForever: 0 // 永久套餐剩余套餐数
  }),
  getters: {
    isSelectForever (state) {
      return state.packageIndexActive === 0 // 位置0是永远套餐
    }
  },
  mutations: {
    vuexChangeLeftCount (state, count) {
      state.leftCountPackageForever = count
    },
    vuexChangeIndexActive (state, index) {
      state.packageIndexActive = index
    }
  },
  actions: {
    loadLeftCount ({ commit }) {
      api.ad.getLeftPackageCount({ data: { pos_code: leftCountPosCode } }).then((res) => {
        const count = res.data.count
        commit('vuexChangeLeftCount', count)
      })
    },
    updateLeftCountByUsePackage ({ dispatch }) {
      api.ad.usePackageCount({ data: { pos_code: leftCountPosCode } }).then(() => {
        dispatch('loadLeftCount')
      })
    }
  }
}
